<template>
    <AuthLayout v-bind="appSharedData.getAuthLayoutProps()">
        <template #title> Create a new password </template>

        <template #card-content>
            <ApiForm
                :url="RoutePathAppEnum.Auth_ForgotMyPassword"
                method="POST"
                ref="apiFormRef"
            >
                <FormControl
                    required
                    label="Email"
                    :error="
                        apiFormRef?.response?.getValidationError(
                            RequestBodyKeyEnum.Auth_User_PasswordReset_Email,
                        )
                    "
                >
                    <TextInput
                        type="email"
                        class="w-full"
                        :name="RequestBodyKeyEnum.Auth_User_PasswordReset_Email"
                        required
                    />
                </FormControl>

                <Button
                    @click="apiFormRef?.submit()"
                    :loading="apiFormRef?.loading.valueOf()"
                    class="w-full mt-2"
                >
                    Send recovery email
                </Button>

                <div
                    v-if="turnstileEnabled"
                    class="mt-4 flex justify-center"
                >
                    <div
                        class="cf-turnstile"
                        :data-sitekey="turnstileSiteKey"
                    ></div>
                </div>
            </ApiForm>
        </template>
    </AuthLayout>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import AuthLayout from '@/Shared/Layout/App/Auth/AuthLayout.vue'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import Button from '@/Shared/Component/Button.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import AppSharedData from '@/Shared/Entity/AppSharedData'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'
    import { RoutePathAppEnum } from '@/Shared/AutoGenerated/RoutePathEnum'

    interface ShowPasswordResetProps {
        appSharedDataData: any
        turnstileEnabled: boolean
        turnstileSiteKey: string
    }

    const props = defineProps<ShowPasswordResetProps>()
    const appSharedData = AppSharedData.hydrate(props.appSharedDataData)
    const apiFormRef = ref<ApiFormRefType>(null)
</script>
